import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 11.6667L10 6.66667L5 11.6667L6.16667 12.8333L10 9L13.8333 12.8333L15 11.6667Z",
		fill: "currentColor"
	})
});
export default SvgCaretUp;
